// src/pages/Account/AccountHistoryPage.jsx
import React from 'react';
import pageStyles from './AccountPage.module.css'; // << MODIFIED: Uncommented and ensured alias

const AccountHistoryPage = () => {
  return (
    <div className={pageStyles.accountPageContainer}> {/* << MODIFIED: Class added */}
      <h2 className="page-main-title">Account History</h2> {/* << MODIFIED: Class added */}
      <p>This is the Account History page. Content will be added here later.</p>
    </div>
  );
};

export default AccountHistoryPage;